import styled from 'styled-components';
import { Flex } from '@rebass/grid';

export const ListSt = styled(Flex).attrs(() => ({
  as: 'ul',
}))`
  justify-content: space-between;
  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItemSt = styled.li`
  display: inline-flex;

  &:not(:last-child) {
    padding-bottom: 8px;
  }
`;
